<!-- 预览视频弹窗 -->
<style lang="scss" scoped>
.video-box {
  max-height: 600px;

  .video {
    display: block;
    width: 100%;
    height: 100%;
    max-height: 600px;
  }
}
</style>

<style lang="scss">
.preview-video-dialog {
  .el-dialog__body {
    padding: 20px;
  }
}
</style>

<template>
  <main class="preview-video-dialog">
    <el-dialog
      v-model="dialogVisible"
      width="800px"
      title="视频预览"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="closeCallBack"
    >
      <div class="video-box">
        <video
          ref="videoRef"
          class="video"
          :src="url"
          controls
        />
      </div>
    </el-dialog>
  </main>
</template>

<script setup lang="jsx">
import { ref } from 'vue'
const dialogVisible = ref(false)
const url = ref('')

const init = data => {
  dialogVisible.value = true
  url.value = data.url
}
const videoRef = ref(null)
// 弹窗关闭回调
const closeCallBack = () => {
  videoRef.value.pause()
}

defineExpose({
  init,
})
</script>
